/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Divider from "@mui/material/Divider";
import doubleDividerStyle from "./doubleDividerStyle";
import Container from "../Container/Container";

function DoubleDivider() {
  return (
    <Container>
      <Divider sx={doubleDividerStyle.dividerGray} />
      <Divider sx={doubleDividerStyle.dividerPrimary} />
    </Container>
  );
}

export default DoubleDivider;
